/*
 * Replace Y/N with dots on the Processes table
 */

const processesTables = [...document.querySelectorAll('.c-processes-table__table')];

/*
 * Replace cell contents
 * @param {object} Takes a td element
 * @return {string} Returns a string of HTML
 */
function replaceText(td) {
  const text = td.textContent;
  const textUpper = text.toUpperCase();
  if (textUpper === 'Y') {
    return '<span class="c-dot c-dot--active"></span>';
  }
  if (textUpper === 'N') {
    return '<span class="c-dot"></span>';
  }
  return text;
}

export default function init() {
  if (processesTables.length) {
    processesTables.forEach((table) => {
      const tds = [...table.querySelectorAll('td')];
      tds.forEach((td) => {
        td.innerHTML = replaceText(td); // eslint-disable-line no-param-reassign
      });
    });
  }
}
